import map from 'lodash/map'
import { StatusEnum } from '@ztechapps/common.contract'
import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'

const companyStatuses = map(StatusEnum, (e) => {
  return e
})

export const companyListFieldConfig: ListFieldConfig = {
  name: {
    name: 'name',
    displayName: 'Company Name',
    defaultOnSearch: true,
    size: 350,
    index: 1,
  },
  city: {
    name: 'address.city',
    displayName: 'City',
    defaultOnSearch: true,
    size: 150,
    index: 2,
  },
  state: {
    name: 'address.state',
    displayName: 'State',
    defaultOnSearch: true,
    size: 150,
    index: 3,
  },
  domain: {
    name: 'domain',
    displayName: 'Domain Name',
    size: 300,
    index: 4,
  },
  contacts: {
    name: 'contacts._id',
    displayName: 'Contacts',
    size: 300,
    index: 5,
    excludeOnFilter: true,
    excludeOnSort: true,
    excludeOnSearch: true,
  },
  tags: {
    name: 'tags',
    size: 200,
    index: 6,
  },
  remarks: {
    name: 'remarks',
    size: 300,
    index: 7,
  },
  status: {
    name: 'status',
    displayName: 'Status',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: companyStatuses,
    },
    size: 100,
    index: 8,
  },
  contactEmail: {
    excludeOnDisplay: true,
    isVisible: false,
    name: 'contacts.profile.email',
    displayName: 'Contact Email',
    size: 100,
  },
  contactPhone: {
    excludeOnDisplay: true,
    isVisible: false,
    name: 'contacts.phone',
    displayName: 'Contact Phone',
    size: 100,
  },
  contactName: {
    excludeOnDisplay: true,
    isVisible: false,
    name: 'contacts.profile.name',
    displayName: 'Contact Name',
    size: 100,
  },
}
